// Tiny synthesized sound effects (no audio files needed) so the app ships with
// zero extra assets. Respects the global sound toggle.
let ctx: AudioContext | null = null;
let enabled = true;

export function setSoundEnabled(v: boolean): void {
  enabled = v;
}

function ac(): AudioContext | null {
  if (typeof window === 'undefined') return null;
  if (!ctx) {
    const AC = window.AudioContext || (window as unknown as { webkitAudioContext: typeof AudioContext }).webkitAudioContext;
    if (AC) ctx = new AC();
  }
  return ctx;
}

function beep(freq: number, dur: number, type: OscillatorType = 'square', gain = 0.05): void {
  if (!enabled) return;
  const a = ac();
  if (!a) return;
  if (a.state === 'suspended') a.resume().catch(() => {});
  const o = a.createOscillator();
  const g = a.createGain();
  o.type = type;
  o.frequency.value = freq;
  g.gain.value = gain;
  o.connect(g);
  g.connect(a.destination);
  const t = a.currentTime;
  g.gain.setValueAtTime(gain, t);
  g.gain.exponentialRampToValueAtTime(0.0001, t + dur);
  o.start(t);
  o.stop(t + dur);
}

export const sfx = {
  place(): void {
    beep(420, 0.05, 'square', 0.04);
  },
  remove(): void {
    beep(220, 0.05, 'square', 0.03);
  },
  clear(): void {
    beep(180, 0.08, 'sawtooth', 0.03);
  },
  craft(): void {
    beep(540, 0.06, 'square', 0.05);
    setTimeout(() => beep(720, 0.08, 'square', 0.05), 60);
  },
  error(): void {
    beep(140, 0.18, 'sawtooth', 0.05);
  },
  click(): void {
    beep(380, 0.03, 'square', 0.03);
  },
};
